import Image from 'next/image'

import type { FC } from 'react'

interface IconProps {
  name?: string
}

const nameIconMappings = [
  'img-book-magnifying-glass-stars.png',
  'img-chalk-board-document-progress.png',
  'img-circulation-progress-chart-data-document.png',
  'img-community-character-emoji-interaction.png',
  'img-presentation-data-chart.png',
  'img-presentation-vision-mission.png',
  'img-reflection-documents-magnifying-glass.png',
  'img-sharing-chat-emoji-characters.png',
]

const Icon: FC<IconProps> = ({ name }) => {
  const fileName = nameIconMappings.includes(name?.trim())
    ? name?.trim()
    : 'img-chalk-board-document-progress.png'

  return (
    <div className="w-[84px] h-[84px] relative">
      {/* Prevent user select */}
      <div className="absolute inset-0 z-10">&nbsp;</div>

      <Image
        alt=""
        src={['/illustrations', fileName].join('/')}
        width={84}
        height={84}
        unoptimized={true}
      />
    </div>
  )
}

export default Icon
